<template>
  <!-- eslint-disable -->
  <div class="medical-location-wrapper">
    <div class="column-left">
      <SideNav />
    </div>

    <div class="column-right">
      <TopNavClean />
      <div v-if="loading === true" class="loading-state">
        <Loader :height="100" :width="100" />
      </div>
      <div v-else class="main-container">
        <!-- Main Content -->
        <div class="location-content">
          <!-- Page Header -->
          <div class="page-header">
            <div class="header-content">
              <div class="title-section">
                <div class="page-icon" :style="{
                  backgroundImage: `linear-gradient(139deg, ${prestador.admin.assets.colors.primary} 0%, ${prestador.admin.assets.colors.secondary} 100%)`
                }">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                </div>
                <div>
                  <h1 class="page-title">Geolocalización de Profesionales</h1>
                  <p class="page-subtitle">Seguimiento en tiempo real de profesionales médicos</p>
                </div>
              </div>

              <div class="header-actions">
                <button class="toggle-btn" :class="{ 'active': mostrando }"
                  :style="{ 'background-color': mostrando ? prestador.admin.assets.colors.primary : '' }"
                  @click="mostrando = !mostrando">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  {{ mostrando ? 'Ocultar' : 'Mostrar' }} Tomadores
                </button>
              </div>
            </div>
          </div>

          <!-- Main Layout -->
          <div class="location-layout">
            <!-- Map Section -->
            <div class="map-section">
              <div class="map-container">
                <div class="map-header">
                  <div class="map-title">
                    <div class="map-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <polygon points="1,6 1,22 8,18 16,22 23,18 23,2 16,6 8,2 1,6"></polygon>
                        <line x1="8" y1="2" x2="8" y2="18"></line>
                        <line x1="16" y1="6" x2="16" y2="22"></line>
                      </svg>
                    </div>
                    <h3>Mapa de Ubicaciones</h3>
                  </div>

                  <div class="map-stats">
                    <div class="stat-badge">
                      <span class="stat-number">{{ profesionales_filtrados.length }}</span>
                      <span class="stat-label">Conectados</span>
                    </div>
                  </div>
                </div>

                <div class="map-wrapper">
                  <div id="mapa" ref="mapa" class="map">
                    <l-map :options="{ attributionControl: false, zoomControl: false }" :zoom="zoom" :center="center"
                      @update:zoom="zoomUpdate" @update:center="centerUpdate">
                      <l-tile-layer :url="url" />
                      <l-circle-marker v-if="circulo.mostrando" :key="key" :lat-lng="[circulo.lat, circulo.lon]"
                        :radius="25" :pane="'shadowPane'" />
                      <l-moving-rotated-marker v-for="p in profesionales_filtrados" :key="p.id" :ref="'marker_' + p.id"
                        :lat-lng="[p.lat, p.lon]" :visible="true" :duration="2000" :rotation-angle="0"
                        :icon="createCustomIcon(p)" @mouseenter="openPopup" @mouseleave="closePopup">
                        <l-popup :id="p.id"
                          :options="{ autoClose: false, autoPan: false, closeOnClick: false, closeButon: false, maxWidth: 'auto' }">
                          <span>
                            {{ p.nombre }} {{ p.apellido }}
                          </span>
                        </l-popup>
                      </l-moving-rotated-marker>
                      <l-control-zoom position="topright" />
                    </l-map>
                  </div>
                </div>
              </div>
            </div>

            <!-- Professionals Panel -->
            <div v-show="mostrando" class="professionals-panel">
              <div class="panel-container">
                <!-- Connected State -->
                <div v-if="socket.connected" class="professionals-content">
                  <div class="panel-header">
                    <div class="panel-title">
                      <div class="panel-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2">
                          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                          <circle cx="9" cy="7" r="4"></circle>
                          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                      </div>
                      <h3>Profesionales en Ruta</h3>
                    </div>

                    <div class="connection-status">
                      <div class="status-indicator connected">
                        <div class="status-dot"></div>
                        <span>Conectado</span>
                      </div>
                    </div>
                  </div>

                  <div class="panel-stats">
                    <div class="stats-card">
                      <div class="stats-content">
                        <div class="stats-number">{{ profesionales_filtrados.length }}</div>
                        <div class="stats-label">Profesionales activos</div>
                      </div>
                      <div class="stats-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2">
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                          <circle cx="9" cy="7" r="4"></circle>
                          <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        </svg>
                      </div>
                    </div>
                  </div>

                  <!-- Professionals List -->

                  <div class="professionals-list scrollable-list">
                    <div v-if="loading === true" class="loading-state">
                      <Loader :height="100" :width="100" />
                    </div>
                    <div v-for="p in profesionales_filtrados" :key="p.id" class="professional-card"
                      @mouseenter="listMouseOver(p)" @mouseleave="listMouseLeave(p)">
                      <div class="professional-avatar">
                        <div class="avatar-circle"
                          :style="{ 'background-color': prestador.admin.assets.colors.primary }">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                            <circle cx="12" cy="7" r="4"></circle>
                          </svg>
                        </div>
                        <div class="status-badge active">
                          <div class="status-pulse"></div>
                        </div>
                      </div>

                      <div class="professional-info">
                        <div class="professional-name">
                          <span v-if="containsKey(p, 'nombre')" class="name-part">{{ p.nombre }}</span>
                          <span v-if="containsKey(p, 'apellido')" class="name-part">{{ p.apellido }}</span>
                        </div>

                        <div v-if="containsKey(p, 'email')" class="professional-email">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z">
                            </path>
                            <polyline points="22,6 12,13 2,6"></polyline>
                          </svg>
                          {{ p.email }}
                        </div>

                        <div v-if="containsKey(p, 'ultima_vez')" class="last-update">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12,6 12,12 16,14"></polyline>
                          </svg>
                          Última actualización hace {{ getTimeDifference(p.ultima_vez) }}
                        </div>
                      </div>

                      <div class="professional-actions">
                        <button class="view-map-btn"
                          :style="{ 'background-color': prestador.admin.assets.colors.primary }"
                          @click="goto(p.lat, p.lon)">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                          </svg>
                          Ver en mapa
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Disconnected State -->
                <div v-else class="disconnected-state">
                  <div class="disconnected-content">
                    <div class="disconnected-icon">
                      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="1.5">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                        <path d="M1 1l22 22"></path>
                      </svg>
                    </div>
                    <h4>Conectando...</h4>
                    <p>Estableciendo conexión con el servidor</p>
                    <div class="connection-loader">
                      <Loader :height="40" :width="40" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import * as L from 'leaflet'
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LGeoJson, LCircle, LCircleMarker, LPopup, LIcon, LControlAttribution, LRectangle, LPolygon, LPolyline, LControlZoom } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import io from 'socket.io-client';
import { mapGetters, mapActions } from 'vuex';
import TopNavClean from './TopNavClean.vue';
import SideNav from '@/components/SideNav.vue';
import Loader from '@/components/Loader.vue';
import LMovingRotatedMarker from 'vue2-leaflet-moving-rotated-marker'
import defaultImage from "@/assets/ia/emptyuser.webp";

export default {
  name: 'HelloWorld',
  props: ['id'],
  components: {
    SideNav,
    Loader,
    TopNavClean,
    LMap,
    LTileLayer,
    LControlZoom,
    LMovingRotatedMarker,
    TopNavClean,
    LPopup,
    LCircleMarker,
  },
  data() {
    return {
      loading: false,
      icon: L.icon({
        iconUrl: require('@/assets/persona.png'),
        iconSize: [30, 30],
        iconAnchor: [15, 15],
        popupAnchor: [0, -7]
      }),
      circulo: { 'mostrando': false, 'lat': 0, 'lon': 0 },
      profesionales: [],
      profesionales_filtrados: [],
      profesionales_posibles: [],
      key: 1,
      socket: undefined,
      mostrando: false,
      zoom: 12,
      center: L.latLng(-33.438926, -70.651746),
      currentCenter: L.latLng(-33.438926, -70.651746),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',

    }
  },
  methods: {
    ...mapActions(['loginAdmin', 'logoutAdmin']),

    createCustomIcon(profes) {
      let profesional_atributos = this.profesionales_posibles.find(x => x.id == profes.id) != null ? this.profesionales_posibles.find(x => x.id == profes.id).atributos : null
      const imageUrl = profesional_atributos && profesional_atributos.foto ? 'https://assets-fotos-profesionales.s3.sa-east-1.amazonaws.com/' + profesional_atributos.foto : defaultImage;
      const iconHtml = `
        <div style="background: white; transform:translate(-2px, -3px); border: 3px solid ${this.prestador.admin.assets.colors.primary}; border-radius: 50%; overflow: hidden; width: 45px; height: 45px;">
          <img src="${imageUrl}" style="width: 100%; height: 100%; object-fit: cover;">
        </div>
      `;

      return L.divIcon({
        html: iconHtml,
        iconSize: [40, 40],
        className: ''
      });
    },

    getProfesionales() {
      this.loading = true;
      this.profesionales_posibles = [];
      axios({ url: window.hostname + '/api/admin/get_profesionales_geo', method: 'GET' })
        .then((r) => {

          this.profesionales_posibles = r.data.profesionales;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        })
    },

    openPopup: function (event) {
      console.log("LOL")
      event.target.openPopup();
    },
    closePopup: function (event) {
      event.target.closePopup();
    },

    getTimeDifference(t) {
      let diff = Date.now() - new Date(t).getTime()
      let minutos = Math.floor(((diff % 86400000) % 3600000) / 60000)
      let segundos = Math.floor((((diff % 86400000) % 3600000) % 60000) / 1000)
      if (minutos > 0)
        return minutos + ' minutos y ' + segundos + (segundos > 1 && segundos != 0 ? ' segundos' : ' segundo')
      return segundos + (segundos > 1 && segundos != 0 ? ' segundos' : ' segundo')

    },
    containsKey(obj, key) {
      return Object.keys(obj).includes(key);
    },
    listMouseOver: function (x) {
      this.circulo.lat = x.lat;
      this.circulo.lon = x.lon;
      this.circulo.mostrando = true;

    },
    listMouseLeave: function (x) {
      this.circulo.mostrando = false;

    },
    goto: function (lat, lon) {
      if (lat != null && lon != null)
        this.center = L.latLng(lat + (Math.random() * 0.000001), lon + (Math.random() * 0.000001));
    },
    zoomUpdate: function (zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate: function (center) {
      this.currentCenter = center;
    },


  },
  watch: {
    profesionales: function (val) {
      this.loading = true;
      this.key += 1;
      this.profesionales_filtrados = []
      let ret = []
      for (var z of this.profesionales) {
        if (!this.profesionales_posibles.some(x => x.id == z.id) && this.prestador.id != 1)
          continue;
        if (z.lat != null && z.lon != null)
          this.profesionales_filtrados.push(z)

      }
      this.loading = false;
      //this.profesionales_filtrados = ret
      this.$forceUpdate();
    }
  },
  computed: {
    ...mapGetters(['comunas', 'regiones', 'prestador', 'prestaciones', 'tipos', 'admin_datos', 'comunas_usadas', 'token']),
  },
  async mounted() {

    await this.getProfesionales();
    this.socket = io(window.socket, {
      extraHeaders: {
        "token": this.token,
        "tipo": "admin",
        "usuario": JSON.stringify(this.admin_datos)
      }
    })
    this.socket.on("connect", () => {
    })
    this.socket.on("emitir_info_admin", (data) => {
      this.profesionales = JSON.parse(data);
    });

    setInterval(() => {
      this.socket.emit('escuchar_info_admin', this.token)

    }, 3000);
  }

}
</script>


<style scoped>
/* Base Styles - Notion-inspired with medical touches */
.medical-location-wrapper {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

.column-left {
  position: fixed;
  left: 0;
  top: 0;
  width: 280px;
  height: 100vh;
  z-index: 1000;
}

.column-right {
  margin-left: 280px;
  min-height: 100vh;
}

.main-container {
  padding: 0;
}

.location-content {
  padding: 2rem;
  max-width: 1600px;
  margin: 0 auto;
}

/* Loading State */
.loading-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 140px);
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  background: white;
  padding: 3rem;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.loading-text {
  color: #64748b;
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
}

/* Page Header */
.page-header {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.page-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.5rem;
  letter-spacing: -0.025em;
}

.page-subtitle {
  font-size: 1.125rem;
  color: #64748b;
  margin: 0;
  font-weight: 400;
}

.header-actions {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1000;
}

.toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: white;
  color: #64748b;
  border: 2px solid #e2e8f0;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  z-index: 10;
  cursor: pointer;
}

.toggle-btn:hover {
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

.toggle-btn.active {
  color: white;
  border-color: currentColor;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Main Layout */
.location-layout {
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 2rem;
  align-items: start;
}

.map-section {
  width: 1350px;
  max-width: 100%;
  margin: 0 auto;
  padding: 1rem;
  box-sizing: border-box;
  background: white;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  overflow: hidden;
}


.map-container {
  display: flex;
  flex-direction: column;
  height: 800px;
}

.map-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.map-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.map-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.map-title h3 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.map-stats {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.stat-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.stat-number {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1;
}

.stat-label {
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 500;
  margin-top: 0.25rem;
}

.map-wrapper {
  flex: 1;
  position: relative;
}

.map {
  width: 100%;
  height: 100%;
  border-radius: 0;
}

/* Professionals Panel */
.professionals-panel {
  background: white;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
  overflow: hidden;
  max-height: 600px;
  display: flex;
  flex-direction: column;
}

.panel-container {
  display: flex;
  flex-direction: column;
  height: 500px;
}

.professionals-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.panel-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #8b5cf6, #7c3aed);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.panel-title h3 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.connection-status {
  display: flex;
  align-items: center;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
}

.status-indicator.connected {
  background: #dcfce7;
  color: #166534;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  animation: pulse 2s infinite;
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }
}

.panel-stats {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.stats-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8fafc;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.stats-content {
  display: flex;
  flex-direction: column;
}

.stats-number {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1;
}

.stats-label {
  font-size: 0.875rem;
  color: #64748b;
  font-weight: 500;
  margin-top: 0.25rem;
}

.stats-icon {
  color: #94a3b8;
}

/* Professionals List */
.professionals-list {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
}

.professional-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  margin-bottom: 1rem;
  transition: all 0.2s ease;
  cursor: pointer;
}

.professional-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  background: white;
}

.professional-card:last-child {
  margin-bottom: 0;
}

.professional-avatar {
  position: relative;
  flex-shrink: 0;
}

.avatar-circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.status-badge {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 16px;
  height: 16px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.status-badge.active {
  background: #22c55e;
}

.status-pulse {
  width: 8px;
  height: 8px;
  background: white;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.professional-info {
  flex: 1;
  min-width: 0;
}

.professional-name {
  font-weight: 600;
  color: #1e293b;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
}

.name-part {
  margin-right: 0.25rem;
}

.professional-email {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  color: #64748b;
  margin-bottom: 0.25rem;
}

.last-update {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  color: #94a3b8;
  font-style: italic;
}

.professional-actions {
  flex-shrink: 0;
}

.view-map-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.view-map-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
}

/* Disconnected State */
.disconnected-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 2rem;
}

.disconnected-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
}

.disconnected-icon {
  color: #94a3b8;
  margin-bottom: 1rem;
}

.disconnected-content h4 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #64748b;
  margin: 0;
}

.disconnected-content p {
  font-size: 0.875rem;
  color: #94a3b8;
  margin: 0;
}

.connection-loader {
  margin-top: 1rem;
}

/* Responsive Design */
@media (max-width: 1400px) {
  .column-right {
    margin-left: 0;
  }

  .location-layout {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .professionals-panel {
    height: 90vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .panel-container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .professionals-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .scrollable-list {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    max-height: none;
  }

  .map-section {
    width: 100%;
    padding: 1rem 0.5rem;
  }
}

@media (max-width: 768px) {
  .location-content {
    padding: 1rem;
  }

  .page-header {
    padding: 1.5rem;
  }

  .header-content {
    flex-direction: column;
    align-items: stretch;
    gap: 1.5rem;
  }

  .title-section {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .page-icon {
    width: 48px;
    height: 48px;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .page-subtitle {
    font-size: 1rem;
  }

  .toggle-btn {
    padding: 0.75rem 1.5rem;
    font-size: 0.875rem;
  }

  .map-container {
    height: 400px;
  }

  .map-header {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }

  .panel-header {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }

  .professional-card {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
    text-align: center;
  }

  .professional-info {
    order: 1;
  }

  .professional-actions {
    order: 2;
  }

  .professional-avatar {
    order: 0;
    align-self: center;
  }

  .professionals-panel {
    height: 90vh;
    overflow-y: auto;
  }

  .scrollable-list {
    max-height: 70vh;
  }
}

@media (max-width: 480px) {
  .location-content {
    padding: 0.5rem;
  }

  .page-header {
    padding: 1rem;
  }

  .map-container {
    height: 300px;
  }

  .professionals-panel {
    max-height: 300px;
  }

  .professional-card {
    padding: 0.75rem;
  }

  .avatar-circle {
    width: 40px;
    height: 40px;
  }

  .view-map-btn {
    padding: 0.5rem 0.75rem;
    font-size: 0.75rem;
  }

  .stats-card {
    padding: 0.75rem;
  }

  .stats-number {
    font-size: 1.25rem;
  }

  .panel-container {
    display: flex;
    flex-direction: column;
    height: 500px;
  }

  .professionals-panel {
    height: 90vh;
    overflow-y: auto;
  }

  .scrollable-list {
    flex: 1;
    overflow-y: auto;
    max-height: none;
    /* quitar limite anterior si existía */
    min-height: 0;
    /* importante para que el scroll funcione dentro de flex */
  }
}

/* Scrollbar Styling */
.professionals-list::-webkit-scrollbar {
  width: 4px;
}

.professionals-list::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 2px;
}

.professionals-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.professionals-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.scrollable-list {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 4px;
}

/* Focus States */
.toggle-btn:focus,
.view-map-btn:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* @media (max-width: 1200px) {
  .map-section {
    width: 1000px;
  }

  .panel-container {
    display: flex;
    flex-direction: column;
    height: 500px;
  }

} */

/* Celulares grandes */
@media (max-width: 768px) {
  .map-section {
    width: 100%;
    padding: 1rem 0.5rem;
  }

  .panel-container {
    display: flex;
    flex-direction: column;
    height: 500px;
  }

}

/* High Contrast Mode */
@media (prefers-contrast: high) {

  .professionals-panel,
  .professional-card {
    border-width: 2px;
  }

  .toggle-btn,
  .view-map-btn {
    border-width: 2px;
  }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {

  .toggle-btn,
  .professional-card,
  .view-map-btn {
    transition: none;
  }

  .status-dot,
  .status-pulse {
    animation: none;
  }
}

/* Dark mode support (if needed) */
@media (prefers-color-scheme: dark) {
  .medical-location-wrapper {
    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  }


  .page-header,
  .map-section,
  .professionals-panel,
  .professional-card {
    background: #1e293b;
    border-color: #334155;
  }

  .map-header,
  .panel-header,
  .panel-stats {
    background: #0f172a;
    border-bottom-color: #334155;
  }

  .page-title,
  .map-title h3,
  .panel-title h3,
  .professional-name,
  .stats-number {
    color: #e2e8f0;
  }

  .page-subtitle,
  .professional-email,
  .last-update,
  .stats-label {
    color: #94a3b8;
  }

  .toggle-btn {
    background: #1e293b;
    border-color: #334155;
    color: #94a3b8;
  }

  .toggle-btn:hover {
    background: #0f172a;
  }

  .professional-card {
    background: #0f172a;
  }

  .professional-card:hover {
    background: #1e293b;
  }

  .stats-card {
    background: #0f172a;
    border-color: #334155;
  }

  .stat-badge {
    background: #1e293b;
    border-color: #334155;
  }

  .disconnected-content h4 {
    color: #94a3b8;
  }

  .disconnected-content p {
    color: #64748b;
  }
}
</style>